var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control lar_input",class:{
    'is-invalid': _vm.hasError
  },attrs:{"id":_vm.id,"type":_vm.type,"placeholder":_vm.placeholder},on:{"input":function($event){$event.preventDefault();return _vm.$emit('input', $event.target.value)},"click":function($event){return _vm.$emit('click', $event)},"focus":function($event){return _vm.$emit('focus', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }